import { Button, Tooltip, Divider, Col, Card } from 'antd'
import Icon, {
    IdcardOutlined,
    MedicineBoxOutlined,
    GiftOutlined,
    UserOutlined,
    EnvironmentOutlined,
    HomeOutlined,
    MailOutlined,
    LinkedinOutlined,
    GithubOutlined,
} from '@ant-design/icons'
import styled, { keyframes } from 'styled-components'

import profile from '../images/profile.jpg'

const ScholarSvg = () => (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
        <path d="M5.242 13.769 0 9.5 12 0l12 9.5-5.242 4.269C17.548 11.249 14.978 9.5 12 9.5s-5.548 1.749-6.758 4.269z" />
        <circle cx="12" cy="17" r="7" />
    </svg>
)

const GoogleScholarOutlined = (props) => <Icon component={ScholarSvg} {...props} />

const fadeInLeft = keyframes`
  from {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`

const FadeInLeftCard = styled(Card)`
  animation: 1s ${fadeInLeft};
`

const ProfileInfo = styled.p`
  font-size: 16px;
`

const ContactIconContainer = styled.div`
  display: flex;
  justify-content: space-between;

  a {
    font-size: 32px;
  }

  a:hover {
    color: #2196f3 !important;
  }
`

const ProfileName = styled.h1`
  text-align: center;
`

const ProfileImageWrap = styled.div`
  padding-left: 36px;
  padding-right: 36px;
  text-align: center;
`

const Motto = styled.p`
  text-align: center;
`

const CONTACTS = [
    {
        title: 'patara.t@kaist.ac.kr',
        href: 'mailto:patara.t@kaist.ac.kr',
        Icon: MailOutlined,
        label: 'Email',
    },
    {
        title: 'itouchz',
        href: 'https://www.linkedin.com/in/itouchz/',
        Icon: LinkedinOutlined,
        label: 'LinkedIn',
    },
    {
        title: 'itouchz',
        href: 'https://github.com/itouchz',
        Icon: GithubOutlined,
        label: 'GitHub',
    },
    {
        title: 'Google Scholar',
        href: 'https://scholar.google.com/citations?user=fDZjV8EAAAAJ',
        Icon: GoogleScholarOutlined,
        label: 'Google Scholar',
    }
]

export default function Profile() {
    return (
        <Col xs={{ span: 24 }} md={{ span: 8 }} lg={{ span: 8 }} xxl={{ span: 6 }}>
            <FadeInLeftCard
                className="black-card"
                style={{ backgroundColor: '#212121' }}
                variant="borderless"
            >
                <Tooltip
                    title={
                        <p>
                            🇹🇭 In Thai Alphabet: ภัทร ไตรรัตน์ (Native)
                            <br />
                            🇰🇷 In Korean Alphabet: 팟타라 따이랏
                        </p>
                    }
                >
                    <ProfileName>PATARA TRIRAT (태현준)</ProfileName>
                </Tooltip>
                <ProfileImageWrap>
                    <img
                        alt="Patara Trirat"
                        src={profile}
                        style={{ maxWidth: 256 }}
                        width="100%"
                        loading="eager"
                    />
                </ProfileImageWrap>
                <Divider style={{ color: '#e91e63', borderBlockStart: 'white' }}>MOTTO</Divider>
                <Motto>
                    NEVER GIVE UP
                    <br />
                    <small>
                        <i>"There is nothing that perseverance cannot win"</i>
                    </small>
                    <br />
                    초부득삼 x 칠전팔기
                </Motto>
                <Divider style={{ color: '#4caf50', borderBlockStart: 'white' }}>
                    PERSONAL INFO
                </Divider>
                <ProfileInfo>
                    <IdcardOutlined /> THAI
                </ProfileInfo>
                <ProfileInfo>
                    <MedicineBoxOutlined /> B
                </ProfileInfo>
                <ProfileInfo>
                    <GiftOutlined /> 1994.05.16
                </ProfileInfo>
                <ProfileInfo>
                    <UserOutlined /> 174 CM - 68 KG
                </ProfileInfo>
                <ProfileInfo>
                    <EnvironmentOutlined /> Shinwoong Tower, 216 Teheran-ro (DeepAuto.ai)
                </ProfileInfo>
                <ProfileInfo>
                    <HomeOutlined /> Seoul, South Korea
                </ProfileInfo>
                <Divider style={{ color: '#2196f3', borderBlockStart: 'white' }}>CONTACT</Divider>
                <ContactIconContainer>
                    {CONTACTS.map(({ title, href, Icon, label }) => (
                        <Tooltip key={href} title={title}>
                            <a
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={label}
                            >
                                <Icon />
                            </a>
                        </Tooltip>
                    ))}
                </ContactIconContainer>
                <br />
                <Button
                    block
                    type="primary"
                    href="files/cv.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Curriculum Vitae (26.08)
                </Button>
            </FadeInLeftCard>
        </Col>
    )
}
